export default __webpack_public_path__ + "static/media/My signature.890a45db.png";